import { ChevronRight } from 'lucide-react';
import NextStepButton from '../../../Components/NextStepButton';
import { StepperNavigationButtons } from '../../../Components/StepperNavigationButtons';
import { useCreateRecruitmentContext } from '../../../Create/Contexts/CreateRecruitmentContext';
import StepProps from '../../StepProps';
import ProcessingState from '@/Models/ProcessingState';
import UIStrings from '@/Utils/UIStrings';

function RequestInformationStepNavigation({ activeStep, handleBack }: StepProps) {
    const { processingState } = useCreateRecruitmentContext();

    return (
        <StepperNavigationButtons
            activeStep={activeStep}
            handleBack={handleBack}
            nextButtonComponent={
                <NextStepButton
                    loading={processingState === ProcessingState.Processing}
                    endIcon={<ChevronRight className="size-5" aria-hidden />}
                >
                    {UIStrings.Next}
                </NextStepButton>
            }
            processingState={processingState}
        />
    );
}

export default RequestInformationStepNavigation;
